import { render, staticRenderFns } from "./onlineCourseSelect.vue?vue&type=template&id=5a579c22&scoped=true&"
import script from "./onlineCourseSelect.vue?vue&type=script&lang=js&"
export * from "./onlineCourseSelect.vue?vue&type=script&lang=js&"
import style0 from "./onlineCourseSelect.vue?vue&type=style&index=0&id=5a579c22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a579c22",
  null
  
)

export default component.exports